import { FC } from "react";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { stylesGeneralComponents } from "../../../StylesMuiGeneralComponents";
import { FetchingSharingStatusData } from "../../../../redux/slices/shareSite/shareSiteTypes";

type ShareSiteFooterParams = {
  selectedStoragesIds: string[];
  multiStorageSharing: (
    selectedStoragesToNotShare: string[],
    selectedStoragesToShare: string[],
    theCorrectIdsToDeleteSharedStorage: string[],
  ) => void;
  sharingStatus: FetchingSharingStatusData;
  toDelete: string[];
};

const ShareSiteFooter: FC<ShareSiteFooterParams> = ({
  selectedStoragesIds,
  multiStorageSharing,
  sharingStatus,
  toDelete,
}) => {
  const [t] = useTranslation("global");

  const sharingStatusObject = sharingStatus.data.map((val) => ({
    id: val.id,
    storageInstanceId: val.storageInstanceId,
    sharingIsForced: val.sharingIsForced,
  }));

  const selectedStoragesToNotShare = sharingStatusObject
    .filter((v) => !toDelete.find((d) => d === v.storageInstanceId))
    .map((val) => val.storageInstanceId);

  const selectedStoragesToShare = selectedStoragesIds
    .filter((v) => !selectedStoragesToNotShare.find((d) => d === v))
    .map((val) => val);

  const theCorrectIdsToDeleteSharedStorage = sharingStatus.data
    .filter((val) => toDelete.find((d) => d === val.storageInstanceId))
    .map((x) => x.id);

  if (
    selectedStoragesToShare.length >= 1 ||
    theCorrectIdsToDeleteSharedStorage.length >= 1
  ) {
    return (
      <div className="share-site-footer-container">
        <div className="share-site-bin-selected-footer">{`${
          selectedStoragesIds.length
        } ${
          selectedStoragesIds.length === 1
            ? t("Share_site.one_stockage_selected")
            : t("Share_site.more_of_one_stockage_selected")
        }`}</div>
        <Button
          onClick={() =>
            multiStorageSharing(
              selectedStoragesToNotShare,
              selectedStoragesToShare,
              theCorrectIdsToDeleteSharedStorage,
            )
          }
          sx={stylesGeneralComponents.buttonStyles}
          variant="contained"
        >
          {t("Common_options.Save")}
        </Button>
      </div>
    );
  } else {
    return "";
  }
};

export default ShareSiteFooter;
